import React from 'react';
import '../styles/App.css';

/**
 * Class used to render the controller table on the SPS2 Info Front End
 *
 * @author Ethan Jones
 */
class ControllerTable extends React.Component{

    state = {
        controllerIndex: -1
    }

    /**
     * Iterates through controllers rendering them inside a table
     * @returns {*}
     */
    renderControllerTable(){
        return(
            this.props.controllers && this.props.controllers.map((data,index) =>(
                <tr>
                    <td onClick={()=>this.props.handleControllerClick(data, index)}
                        className={this.props.controllerIndex === index ? "selectedRow" :""}>{data}</td>
                </tr>

            ))
        )
    }

    /**
     * Main render method of class
     * @returns {*}
     */
    render(){

        return(

            <div>
                <label className={"ControllerTableLabel"}>
                    Select Controller
                </label>
                <div className={"ControllerTableContainer"}>
                <table>
                        {this.renderControllerTable()}
                </table>
                </div>

            </div>

        )
    }
}

export default ControllerTable;